import { LessonLink } from "@jelly/lesson";
import { findChapterForLinkByCourseLesson } from "../../../../services/Utils";
import course04 from "../../../course/course-04/course";
import lesson0406 from "../lesson-06/lesson";
import lesson0427 from "../lesson-27/lesson";

const lessonLinks: LessonLink[] = [
  {
    id: "405b5a9a-869a-44c6-8d67-94f49d934703",
    course: {
      id: course04.id,
      slug: course04.slug as string,
      name: course04.name,
      publicId: course04.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course04, lesson0406),
    lesson: lesson0406,
  },
  {
    id: "3d381b41-d816-4eb5-8398-575d326c828d",
    course: {
      id: course04.id,
      slug: course04.slug as string,
      name: course04.name,
      publicId: course04.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course04, lesson0427),
    lesson: lesson0427,
  },
];

export default lessonLinks;
